export default __webpack_public_path__ + "static/media/available_default_cached_selected.2eb535c0.svg";